class StarRating {
    constructor() {
        this.ratingLinks = document.querySelectorAll('.miniReviewLink');
        this.detailTabs = document.getElementById('detailTabs');
    }

    init = () => {
        this.ratingLinks.forEach(link => {
            link.removeEventListener('click', this.toggle);
            link.addEventListener('click', this.toggle);
        });
    }

    toggle = (e) => {
        e.preventDefault();
        const reviewTrigger = e.target;
        const isExpanded = reviewTrigger.classList.contains("showRating");
        
        if (isExpanded) {
            this.hide(reviewTrigger);
        } else {
            this.show(reviewTrigger);
        }
    } 

    show = (trigger) => { 
        this.closeAnyOpen();
        const dropdown = trigger.nextElementSibling;
        const dropdownLink = dropdown.querySelector('a');

		trigger.classList.add("showRating");
        dropdown.inert = false;
		dropdown.classList.remove("hide");

        // Listen for Escape key
        document.addEventListener('keydown', this.closeOnEsc);

        // Go to reviews on click if it's the details page
        const isDetailsPage = dropdown.closest('.ratingPlaceholder') !== null;
        if (isDetailsPage) {
            dropdownLink.addEventListener('click', this.goToReviews);
        }
    }

    hide = (trigger) => {
        const dropdown = trigger.nextElementSibling;
        dropdown.classList.add("hide");
		dropdown.inert = true;

		trigger.classList.remove("showRating");
        document.removeEventListener('keydown', this.closeOnEsc);
    }

    closeAnyOpen = () => {
        this.ratingLinks.forEach(trigger => {
            if (trigger.classList.contains("showRating")) {
                this.hide(trigger);
            }
        });
    }

    closeOnEsc = (e) => {
        if (e.key === "Escape") {
            this.closeAnyOpen();
        }
    }

    waitForTabsToAppear = (activatedTabId) => {
        if (!this.detailTabs) return;

        this.detailTabs.scrollIntoView();

        const callback = (mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const tab = document.getElementById(activatedTabId);
                    if (tab) {
                        tab.click();
                        tab.focus();
                        observer.disconnect();
                    }
                }
            }
        };

        const tabObserver = new MutationObserver(callback);
        tabObserver.observe(this.detailTabs, { childList: true, subtree: true });
    }

    goToReviews = (e) => {
        e.preventDefault();

        if (document.querySelector('a.anchor[name="reviews"]')) {
            return;
        }

        this.closeAnyOpen();

        const reviewTab = document.getElementById("reviewsTS");
        if (!reviewTab) {
            this.waitForTabsToAppear("reviewsTS");
        } else {
            reviewTab.click();
            reviewTab.focus();
        }
    }
}

export default new StarRating();